
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';

@Component
export default class SupplyAlertDialog extends Vue {
  @Prop(Boolean) readonly value!: boolean;

  dialog = false

  @Watch('value')
  onValueChange(val: boolean) {
    console.log(`${this.constructor.name}: onValueChange()`); // eslint-disable-line no-console

    this.dialog = val;
  }

  @Watch('dialog')
  onDialogChange(val: boolean) {
    if (this.value !== val) {
      this.$emit('input', val);
    }
  }

  async onCancel() {
    console.log(`${this.constructor.name}: onCancel()`); // eslint-disable-line no-console

    this.dialog = false;
  }

  async onEdit() {
    console.log(`${this.constructor.name}: onEdit()`); // eslint-disable-line no-console

    this.dialog = false;

    this.$emit('edit');
  }
}
